var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar-option',{attrs:{"type":"stacked"}},[_c('template',{slot:"primary"},[_c('input',{attrs:{"type":"text"},domProps:{"value":_vm.url},on:{"input":_vm.onInput}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }